import { render, staticRenderFns } from "./BackStory.vue?vue&type=template&id=dae18e24"
import script from "./BackStory.vue?vue&type=script&lang=js"
export * from "./BackStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports